var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFsLogoColori(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.444,
    height: 33.497,
    viewBox: "0 0 49.444 33.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8064",
    "data-name": "Rectangle 8064",
    width: 49.444,
    height: 33.497,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15786",
    "data-name": "Group 15786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15786-2",
    "data-name": "Group 15786",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33522",
    "data-name": "Path 33522",
    d: "M20.926,29.083l-10.768,1.09L2.9,44.559c5.74,0,8.687-.558,12.044-5.342a100.372,100.372,0,0,0,5.982-10.134",
    transform: "translate(-1.412 -14.164)",
    fill: "#00544c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33523",
    "data-name": "Path 33523",
    d: "M59.04,1.6,59.865,0H37.229C29.554,0,25.638,2.6,23.255,7.4c-1.863,3.762-1.857,3.764-1.857,3.764H31.68c3.657-7,8.112-9.416,19-9.565Z",
    transform: "translate(-10.421 0)",
    fill: "#00544c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33524",
    "data-name": "Path 33524",
    d: "M75.162,6.133c-13.8.12-16.1,2.367-19.226,8.021l15.271.007Z",
    transform: "translate(-27.242 -2.987)",
    fill: "#00544c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33525",
    "data-name": "Path 33525",
    d: "M33.284,35.493A12.435,12.435,0,0,1,23.276,45.508a37.536,37.536,0,0,1-5.046.535c-2,0-18.23,0-18.23,0l.7-1.433s6.173-.048,7-.048a57.04,57.04,0,0,0,5.985-.418,10,10,0,0,0,8.867-7.42l1.227-4.159a7.493,7.493,0,0,1,7.355-6.059l11.811-.746-.565,1.13-3.638.224a5.68,5.68,0,0,0-5.181,5Z",
    transform: "translate(0 -12.545)",
    fill: "#c00020"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsLogoColori);
export default __webpack_public_path__ + "static/media/fs_logo_colori.24f62a0924d07a8afbea843e620cae8c.svg";
export { ForwardRef as ReactComponent };